<template>
    <div class="paysolus-notice">
        <p>본 상품권의 선불전자지급수단 발행·관리 및 운영 업무는 「전자금융거래법」에 따라 등록된 <br />선불전자금융업자 페이솔루스에서 관리합니다.</p>
        <p>선불전자지급수단 발행 및 관리업 등록번호 02-002-00020</p>
        <p class="mt-8px">상품권의 구매, 충전, 환불과 고객문의 사항은 페이솔루스의 이용약관 및 상품권 운영 정책에 따릅니다.</p>

        <v-img src="/images/paysolus-logo.png" alt="PAYSOLUS" max-width="150" class="mx-auto mt-20px mt-lg-40px"></v-img>
    </div>
</template>

<script>
// 페이솔루스 발행대행(화이트라벨링) 법적 고지.
// 상품권 구매 화면과 캐시충전 화면 두 곳에서 같은 문구를 쓴다.
// 등록번호나 문구가 바뀌면 이 파일만 고치면 된다 — 복사해서 심어두면
// 한쪽만 고쳐진 채로 두 화면이 서로 다른 말을 하게 된다.
//
// 첫 문장의 줄바꿈은 "등록된" 뒤로 고정한다. 두 화면 모두 폭이 780~800px라
// 이 문장이 한 줄에 들어가지 않는데, 놔두면 끊기는 자리가 화면마다 달라진다.
//
// 글자 크기·색·정렬은 일부러 지정하지 않는다. 두 화면의 주변 문구가
// v-card-text 에서 값을 물려받고 있어서, 여기서 값을 박으면 그 화면에서만
// 혼자 겉돈다. 정렬은 화면마다 달라서(구매는 가운데, 충전은 왼쪽)
// 쓰는 쪽에서 정한다.
export default {
    components: {},
    props: {},
    setup: () => ({}),
    data: () => ({}),
    computed: {},
    methods: {},
    watch: {},
    mounted() {},
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped>
.paysolus-notice {
    & > p {
        margin: 0;
    }
}
</style>
